import { LanguageCode } from "@/graphql/generated";

export const SITE_NAME = "EFTDB";
export const SUPPORTED_LANG = [LanguageCode.En,LanguageCode.Ja];